export default __webpack_public_path__ + "static/media/26-annual-picnic-prize-giving.1696aec6.jpeg";